<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Link Lightspeed Locations</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h3 *ngIf="loadingLightspeedLocations || loadingCapitanLocations" class="text-secondary">Loading locations...</h3>

    <ng-container *ngIf="!(loadingLightspeedLocations || loadingCapitanLocations)">
      <label>Select which Lightspeed location is associated with each Capitan location:</label>

      <div class="alert alert-info">
        This link is used to associate point-of-sale purchases with their Capitan location, for reporting purposes.
      </div>

      <table class="table">
        <thead>
        <tr>
          <th>Capitan Location</th>
          <th>Lightspeed Location</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let capitanLocation of capitanLocations">
          <td>{{ capitanLocation.name }}</td>
          <td class="table-button-cell">
            <select class="custom-select custom-select-sm" [(ngModel)]="capitanLocation.lightspeed_location_id">
              <option [ngValue]="''">
                None
              </option>
              <option *ngFor="let lightspeedLocation of lightspeedLocations" [ngValue]="lightspeedLocation.id">
                {{ lightspeedLocation.name }}
              </option>
            </select>
          </td>
        </tr>
        </tbody>
      </table>
    </ng-container>

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
